import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es6.array.slice.js";
import "regenerator-runtime/runtime.js";

// a basic in memory queue with an asynchronous api
var MemoryQueueAsync = /*#__PURE__*/function () {
  function MemoryQueueAsync() {
    _classCallCheck(this, MemoryQueueAsync);

    this.queue = [];
  }

  _createClass(MemoryQueueAsync, [{
    key: "enqueue",
    value: function () {
      var _enqueue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$queue;

        var _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$queue = this.queue).push.apply(_this$queue, _args));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function enqueue() {
        return _enqueue.apply(this, arguments);
      }

      return enqueue;
    }()
  }, {
    key: "dequeue",
    value: function () {
      var _dequeue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var limit,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                limit = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;

                if (limit) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", this.queue.splice(0, this.queue.length));

              case 3:
                if (!(typeof limit !== 'number')) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('queue.dequeue: first argument must be a number');

              case 5:
                if (!(limit < 0)) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('queue.dequeue: cannot dequeue a negative number of items');

              case 7:
                return _context2.abrupt("return", this.queue.splice(0, limit));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function dequeue() {
        return _dequeue.apply(this, arguments);
      }

      return dequeue;
    }()
  }, {
    key: "toArray",
    value: function () {
      var _toArray = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.queue.slice());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function toArray() {
        return _toArray.apply(this, arguments);
      }

      return toArray;
    }()
  }]);

  return MemoryQueueAsync;
}();

export { MemoryQueueAsync as default };